import './SubmenuSidebar.css';

import React, { useEffect, useState } from 'react';
import SideMenu, { SideMenuLink } from '@amzn/meridian/side-menu';

import Heading from '@amzn/meridian/heading';
import Loader from '@amzn/meridian/loader';
import { useHistory } from 'react-router-dom';

/*
 * Reusable sidebar that consists of simple links that put hrefs into the history.
 * Example usage:
 * const resourceLinks = [
 *     {
 *         title: 'My configuration',
 *         subtitle: 'tiny configuration desc',
 *         href: '/resources/configuration'
 *     },
 *     //...
 * ]
 * const [resourcesLoading, setResourcesLoading] = useState(true);
 * const loadResources = () => {
 *     // do resource loading
 *     setResourcesLoading(false);
 * }
 * const reloadResources = () => {
 *     setResourcesLoading(true);
 *     loadResources();
 * }
 * return (
 * <SubmenuSidebar
 *     title='My resources'
 *     linkItems={resourceLinks} // about these, below
 *     reloadingDataAllowed={true}
 *     isDataLoading={resourcesLoading}
 *     reloadDataFunc={reloadResources}
 *     showLoadingSpinnerAtTitle={true}
 * />
 * // etc
 * );
 *
 * Menu items (linkItems prop) have these parameters:
 * 1. title - title of the link (the main text)
 * 2. subtitle - subtitle of the link (would be smaller font text belowe the title)
 * 3. href - which href to go to
 */
const SubmenuSidebar = ({
  title,
  linkItems,
  reloadingDataAllowed = false,
  isDataLoading,
  reloadDataFunc,
  showLoadingSpinnerAtTitle = false,
}) => {
  const history = useHistory();

  const [currentlySelectedId, setCurrentlySelectedId] = useState(null);
  const [animatingReloadButton, setAnimatingReloadButton] = useState(false);

  useEffect(() => {
    const pathname = history.location.pathname;
    linkItems.forEach(item => {
      if (pathname === item?.href) {
        setCurrentlySelectedId(item.title);
        return;
      }
    });
  });

  return (
    <div className="d-flex h-100">
      <SideMenu titleComponent={Heading} minWidth={260} maxWidth={260}>
        <Heading level={5}>
          {title}
          <div className={showLoadingSpinnerAtTitle ? 'd-inline-block ml-1' : 'd-none'}>
            {isDataLoading && <Loader type="circular" size="small" />}
          </div>
          <div className={reloadingDataAllowed ? 'd-inline' : 'd-none'}>
            <button
              disabled={!reloadingDataAllowed || isDataLoading}
              onClick={() => {
                setAnimatingReloadButton(true);
                reloadDataFunc();
              }}
              onAnimationEnd={() => setAnimatingReloadButton(false)}
              className={'icon-spinner11 btn btn-sm button-round-light' + (animatingReloadButton ? ' rotate-360' : '')}
            >
              {'    '}
            </button>
          </div>
        </Heading>
        {linkItems.map(item => {
          return (
            <SideMenuLink
              disabled={isDataLoading}
              key={item.title}
              href={item.href}
              selected={currentlySelectedId === item.title}
              onClick={() => {
                setCurrentlySelectedId(item.title);
                history.push(item.href);
              }}
            >
              {item.title} {<br />}
              {<small className="text-muted">{item.subtitle}</small>}{' '}
              {isDataLoading && (
                <div className="d-inline-block ml-2">
                  <Loader size="small" />
                </div>
              )}
            </SideMenuLink>
          );
        })}
      </SideMenu>
    </div>
  );
};

export default SubmenuSidebar;
